<template>
  <div class="container is-fluid">
      <div class="columns">
        <div class="column"  style="margin: 00px 15%; font-family:Helvetica">
        <div class="columns">
        <div class="column is-three-fifths"> 
        <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body ">
              <p class="title has-text-white">Trompe L'oeil</p>
              <p class="subtitle has-text-white">
                Welcome in the world of Emanuele Viscuso's decoration.
                <br/><br/>
                For purchase proposals and custom productions, please <router-link class="link" :to="{ name: 'Contact' }">contact</router-link> directly Mr. Viscuso.
                
                <br/><br/>
                Look at the designs, admire the details, study the exemples of compositions, see the pictures of decorated homes and objects, enter in his residences, read the dedicated articles, test the potential of your home.
              <br/><br/><ul>
              <li><a><router-link class="link" :to="{ name: 'TrompeLoeilPdf' }">Catalogue of prices</router-link></a></li>
              <li><a v-on:click="scrollToAnchorPoint('exCompo')" >Examples of compositions</a></li>
              <li><a v-on:click="scrollToAnchorPoint('decHomes')">Decorated homes</a></li>
              <li><a v-on:click="scrollToAnchorPoint('decObjects')">Decorated objects</a></li>
              </ul>
              </p>
            </div>
          </section></div>
        </div>
          <div>
            <div class="aboutimage">
              <img
              src="images2/LogoViscuso0030.jpg"
              alt="Emanuele Viscuso"
              style="margin: -50px 00px"
            /><br />
            <img
              src="loghi/Animation designs.gif"
              alt="Emanuele Viscuso"
              text-align="center"
              style="margin: 00px 00px"
            /><br /></div>
            </div>
            
            <h1>
                What is Trompe l'oeile ?
            </h1>
            <br/><br/><br/><br/><br/>
            <h2 class="abouttext">
            
              <h3>“Trompe l’oeil” is a special tecnique to decorate walls with a tridimentional effect.
                The most beautiful European palaces and “villas” have been decorated by the masters of the time. Mantegna was one of these masters during the Renaissance.
                Also to-day it is possible to realize an expensive “Trompe l’oeil” handmade.
                Another (less expensive) way is to buy a “trompe l’oeil wallpaper. The market offers many different firm at different prices.

                Emanuele Viscuso represents the more wellknown firm in the world with the finest designs sold in many different countries. You can easily use his modular designs to create your own decorations and have the most elegant and cozy results for your home, office or hotel. Many of the best hotels in the world have been decorated with this tecnique

                Viscuso’s murals are printed in Italy on paper sheets and can be assembled; as to form a bookcase or anything else, according to one’s taste.
                They are easy to affix with paper paste on to any surface: from walls, doors, screens, cupboards and tables, to fridge’s – in fact any surface one chooses to adorn with them.
                These beautiful “Trompe l’oeil” murals are a simple and effective way to transform a room and create a very special atmosphere.

                Viscuso is without any doubt the founder of a decorative renaissance.</h3>
                <br/><br/>
            </h2>
          </div>
          
      </div>
      <div>
          <h1 id="exCompo" ref="exCompo">
               Examples of compositions <br/><br/>
            </h1></div>
      <section class="gallery" style="margin: 00px 15%">
      
    <div class="columns">
    
      <div class=" column is-4">
      
        <figure class="img-container">
          <img class="imgGallery" src="trompe_example/img/4.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Italian porcelain</h2>
            <h3 class="category">Example wallpaper</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Italian porcelain</h2>
            <h3 class="category">Example wallpaper</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-4">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_example/img/6.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Italian mosaic</h2>
            <h3 class="category">Example wallpaper</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Italian mosaic</h2>
            <h3 class="category">Example wallpaper</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-4">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_example/img/7.jpg">
          <figcaption class="img-content">
            <h2 class="title">The Library</h2>
            <h3 class="category">Example wallpaper</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">The Library</h2>
            <h3 class="category">Example wallpaper</h3>
          </span>
        </figure>
      </div>
      </div>
      <div class="columns">
      <div class=" column is-6">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_example/img/19.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Renaissance wall</h2>
            <h3 class="category">Example wallpaper</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Renaissance wall</h2>
            <h3 class="category">Example wallpaper</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-6">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_example/img/DECOUPAGE.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Mosaic</h2>
            <h3 class="category">Example wallpaper</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Mosaic</h2>
            <h3 class="category">Example wallpaper</h3>
          </span>
        </figure>
      </div>
      </div>
      <div class="columns">
      <div class="column">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_example/img/Mantegna.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Mantegna</h2>
            <h3 class="category">Example wallpaper</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Mantegna</h2>
            <h3 class="category">Example wallpaper</h3>
          </span>
        </figure>
      
      
    </div>
  </div>
</section>
<div>
          <h1 id="decHomes" ref="decHomes">
               Decorated Homes <br/><br/>
            </h1></div>
      <section class="gallery" style="margin: 00px 15%">
      
    <div class="columns">
    
      <div class=" column is-4">
      
        <figure class="img-container">
          <img class="imgGallery" src="trompe_pictures/casavivapagina1.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Casa magazine</h2>
            <h3 class="category">Decorated Homes</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Casa magazine</h2>
            <h3 class="category">Decorated Homes</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-4">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_pictures/1casaMaggi.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Casa Maggi</h2>
            <h3 class="category">Decorated Homes</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Casa maggi</h2>
            <h3 class="category">Decorated Homes</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-4">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_pictures/14casaGrisaffi.jpg">
          <figcaption class="img-content">
            <h2 class="title">Casa Grisaffi</h2>
            <h3 class="category">Decorated Homes</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Casa Grisaffi</h2>
            <h3 class="category">Decorated Homes</h3>
          </span>
        </figure>
      </div>
      </div>
      <div class="columns">
      <div class=" column is-6">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_pictures/16casaMari.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Casa Mari</h2>
            <h3 class="category">Decorated Homes</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Casa Mari</h2>
            <h3 class="category">Decorated Homes</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-6">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_pictures/casavivapagina8.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Casa Vivapagina</h2>
            <h3 class="category">Decorated Homes</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Casa Vivapagina</h2>
            <h3 class="category">Decorated Homes</h3>
          </span>
        </figure>
      </div>
      </div>
      <div class="columns">
      <div class="column">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_example/img/Casamia30066.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Casa mia</h2>
            <h3 class="category">Decorated Homes</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Casa mia</h2>
            <h3 class="category">Decorated Homes</h3>
          </span>
        </figure>
      
      
    </div>
  </div>
</section>
<div>
          <h1 id="decObjects" ref="decObjects">
               Decorated Objects <br/><br/>
            </h1></div>
      <section class="gallery" style="margin: 00px 15%">
      
    <div class="columns">
    
      <div class=" column is-4">
      
        <figure class="img-container">
          <img class="imgGallery" src="trompe_objects/armadio.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Armadio</h2>
            <h3 class="category">Decorated object</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Armadio</h2>
            <h3 class="category">Decorated object</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-4">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_objects/baule.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Baule</h2>
            <h3 class="category">Decorated object</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Baule</h2>
            <h3 class="category">Decorated object</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-4">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_objects/lampada.jpg">
          <figcaption class="img-content">
            <h2 class="title">Lampada</h2>
            <h3 class="category">Decorated object</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Lampada</h2>
            <h3 class="category">Decorated object</h3>
          </span>
        </figure>
      </div>
      </div>
      <div class="columns">
      <div class=" column is-6">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_objects/armadio.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Armadio</h2>
            <h3 class="category">Decorated object</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Armadio</h2>
            <h3 class="category">Decorated object</h3>
          </span>
        </figure>
      </div>
      <div class=" column is-6">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_objects/paravento.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Paravento</h2>
            <h3 class="category">Decorated object</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Paravento</h2>
            <h3 class="category">Decorated object</h3>
          </span>
        </figure>
      </div>
      </div>
      <div class="columns">
      <div class="column">
        <figure class="img-container">
          <img class="imgGallery" src="trompe_objects/sedia.jpg" />
          <figcaption class="img-content">
            <h2 class="title">Sedia</h2>
            <h3 class="category">Decorated object</h3>
          </figcaption>
          <span class="img-content-hover">
            <h2 class="title">Sedia</h2>
            <h3 class="category">Decorated object</h3>
          </span>
        </figure>
      
      
    </div>
  </div>
</section>
      
    </div>
</template>

<script>
export default {
  name: "TrompeLoeil",
  components: {},
  computed: {},
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName];
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  padding: 0 0 4rem 0;
}

.img-container {
  width: 100%;
  height: 500px;
  cursor: pointer;
  overflow: hidden;
  &:hover .img-content-hover {
    display: block;
  }
}

.imgGallery {
  padding: 10px;
  width: 100%;
  height: 500px;
  object-fit: cover;
  transform: scale(1);
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
}

.img-content {
  display: none;
}
.img-content-hover {
  z-index: 10;
  position: fixed;
  top: 50px;
  left: 50px;
  white-space: nowrap;
  display: none;
  padding: 1rem;
  background: #5b5b5b;
  font-weight: 400;
  margin-top: 1.25rem;
  margin-left: -2rem;
}

.title {
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
}

.category {
  font-size: 1rem;
  color: white;
}

@media screen and (max-width: 1024px) {
  img:hover {
    transform: none;
  }

  .img-container {
    height: 100%;
    &:hover .img-content-hover {
      display: none;
    }
  }

  .img-content {
    display: block;
  }
}

.container {
  background-color: #040303;
  background-attachment: fixed;
  background-size: cover;
  color: #fff;
}

.link {
  color: #9dc7de;
  transition: 0.3s color ease;

  &:hover {
    color: #e48353;
  }
}

a {
  color: #9dc7de;
  transition: 0.3s color ease;
}
a:hover {
  color: #e48353;
}
.bigimage {
  width: 80%;
}

.midimage {
  width: 50%;
}

.abouttext {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: justify;
}

.aboutimage {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: center;
}

h1 {
  font-family: "Helvetica";
  font-size: 2em;
  font-weight: bold;
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}
</style>
